import * as Sentry from "@sentry/react";

export const SentryConfig = {
    dsn: process.env.REACT_APP_ENV === 'local' ? "" : process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0
};